import type { AppThunk } from 'state';
import DataServiceProductProviders from 'common/dataService/services/productProviders';
import FetchingStatus from 'constants/statuses/FetchingStatus';
import { setFetching, setHotelProviders } from '../slice';

function fetchHotelProviders(): AppThunk {
  return async function fetchHotelProvidersThunk(dispatch, getState) {
    try {
      const { fetching } = getState().dataService.productProviders.hotelProviders;

      if (fetching === FetchingStatus.InProgress) {
        return;
      }

      dispatch(setFetching(FetchingStatus.InProgress));

      const data = await DataServiceProductProviders.getHotelProviders();

      if (!data) {
        dispatch(setFetching(FetchingStatus.Failed));
        return;
      }

      dispatch(setHotelProviders(data));
      dispatch(setFetching(FetchingStatus.Succeeded));
    } catch (error) {
      dispatch(setFetching(FetchingStatus.Failed));
      window.Rollbar.error(error);
    }
  };
}

export default fetchHotelProviders;
